import pythonLogo from "../../assets/images/pythonLogo.png";
import circuitLogo from "../../assets/images/circuitLogo.png";
import htmlLogo from "../../assets/images/HTML.svg";
import scratchLogo from "../../assets/images/vc3 logo.png";
import vcJrLogo from "../../assets/images/vc jr logo.png";
import jsLogo from "../../assets/images/jsLogo.png";
import sqlLogo from "../../assets/images/sqlLogo.png";
import geekyBirdLogo from "../../assets/images/geekyBirdLogo.png";
import geekyBirdLogoProgrammable from "../../assets/images/geekyBirdLogoProgrammable.png";
import codeCompatLogo from "../../assets/images/codeCompat.png";
import danceMatLogo from "../../assets/images/dancemat.png";
import ninjaLogo from "../../assets/images/ninjaLogo.png";
import webtypistLogo from "../../assets/images/typing.png";
import mitLogo from "../../assets/images/mitLogo.png";
import makeCodeLogo from "../../assets/images/makecode_logo.png";
import tuxpaintLogo from "../../assets/images/tux_paint_logo.png";
import aiforoceansLogo from "../../assets/images/ai_for_oceans.png";
import gslideLogo from "../../assets/images/gslide_logo.png";
import gdocsLogo from "../../assets/images/gdocs_logo.png";
import gsheetLogo from "../../assets/images/gsheet_logo.png";
import gformsLogo from "../../assets/images/gforms_logo.png";
import arduinoLogo from "../../assets/images/arduino.png";
import { global_var } from "../../services/cs-lab-config";
import ReactGA from "react-ga4";

const projectStackMetaMapping = {
  html_css: {
    logo: htmlLogo,
    route: "/htmlcsside/",
    projectStackDisplayName: "HTML/CSS/JS",
    defaultFileName: "index.html",
    showLabQuestion: true,
    createProjectsInProjects: true,
    description:
      "The HyperText Markup Language or HTML is the standard markup language for documents designed to be displayed in a web browser.",
    coverColor: '#7090F5',
    tutorialVideoUrl: 'https://www.youtube.com/embed/Ztq_4jmzriY?si=uj4OvOm6lMMz7Wxk'
  },
  python: {
    logo: pythonLogo,
    route: "/pythonide/",
    projectStackDisplayName: "Python",
    defaultFileName: "main.py",
    showLabQuestion: true,
    createProjectsInProjects: true,
    description:
      "Python is a high-level, general-purpose programming language.",
    coverColor: '#7090F5',
    tutorialVideoUrl: 'https://www.youtube.com/embed/rxt9cqiqE8o?si=MuKl1JmtDdCIsi-k'
  },
  circuit: {
    logo: circuitLogo,
    route: "/flowcircuit/",
    projectStackDisplayName: "CS Flow & Circuit",
    // defaultFileName: "main.py",
    // showLabQuestion: true,
    createProjectsInProjects: true,
    description:
      "sketch, connect, and simulate circuit diagrams with an intuitive drag-and-drop interface.",
    coverColor: '#76d0b7',
    // tutorialVideoUrl: 'https://www.youtube.com/embed/rxt9cqiqE8o?si=MuKl1JmtDdCIsi-k'
  },
  scratch: {
    logo: scratchLogo,
    projectStackDisplayName: "Scratch",
    description:
      "Scratch is a high-level block-based visual programming language and website aimed primarily at children as an educational tool, with a target audience of ages 8 to 16.",
    coverColor: '#D7BEF7'
  },
  vc3: {
    logo: scratchLogo,
    projectStackDisplayName: "Scratch",
    route: "/vc3/",
    showLabQuestion: true,
    description:
      "Scratch is a block-based programming language with AI features, designed for children aged 8 to 16 to learn and create smart interactive projects easily.",
    aiPowered: true,
    aiBadge: {
      desktop: "AI Powered",
      mobile: "AI",
    },
    coverColor: '#D7BEF7',
    tutorialVideoUrl: 'https://www.youtube.com/embed/gZlhglCmOZg?si=2DEskO2tIETLvF5b'
  },
  scratchjr: {
    logo: vcJrLogo,
    projectStackDisplayName: "Scratch Jr",
    route: "/scratchjr/",
    description:
      "Scratch Jr is a visual programming language designed to introduce programming skills to children ages 5–7.",
    coverColor: '#D7BEF7',
    tutorialVideoUrl: 'https://www.youtube.com/embed/wKyD9yRp_gs?si=UFVrxHIzVlnNl_sw'
  },
  javascript: {
    logo: jsLogo,
    route: "/htmlcsside/",
    projectStackDisplayName: "JavaScript",
    description:
      "JavaScript, often abbreviated as JS, is a programming language that is one of the core technologies of the World Wide Web.",
    coverColor: '#FEF8F8',
  },
  sql2: {
    logo: sqlLogo,
    projectStackDisplayName: "SQL",
    route: "/sqlide/",
    showLabQuestion: true,
    description:
      "Structured Query Language, is a domain-specific language used in programming and designed for managing data held in a relational database management system.",
    coverColor: '#FEF8F8',
    tutorialVideoUrl: 'https://www.youtube.com/embed/f-7lsZjs1lM?si=SIwM77EggUC0vO2w'
  },
  codeCombat_game: {
    logo: codeCompatLogo,
    route: "/codecompat/",
    hideMyProjects: true,
    projectStackDisplayName: "CodeCombat Game",
    description:
      "CodeCombat is an educational video game for learning software programming concepts and languages.",
    coverColor: '#7090F5',
  },
  geekyBird_game: {
    logo: geekyBirdLogo,
    route: "/geekybird/",
    hideMyProjects: true,
    projectStackDisplayName: "Geeky Bird Game",
    description:
      "Players can control the bird's flight by answering math questions correctly, making learning an enjoyable adventure",
    coverColor: '#7090F5',
  },
  geekyBird_game_programmable: {
    logo: geekyBirdLogoProgrammable,
    route: "/geekybirdpr/",
    hideMyProjects: true,
    projectStackDisplayName: "Geeky Bird Game Programmable",
    description:
      "This is a customizable web-based game that allows players to personalize the appearance of their in-game bird character.",
    coverColor: '#7090F5',
  },
  dance_mat_typing: {
    logo: danceMatLogo,
    route: "/dancemat/",
    hideMyProjects: true,
    projectStackDisplayName: "Dance Mat Typing",
    description:
      "Dance Mat is great fun! It shows us how to type using the correct fingers.",
    coverColor: '#D7BEF7',
  },
  typing_ninja: {
    logo: ninjaLogo,
    route: "/typingninja/",
    hideMyProjects: true,
    projectStackDisplayName: "Typing Ninja",
    description:
      "Typing Ninja gives you easy, medium, or hard typing practice so you can improve your typing skills.",
    coverColor: '#D7BEF7',
  },
  web_typist: {
    logo: webtypistLogo,
    route: "/webtypist/",
    projectStackDisplayName: "CS Typing Tutor",
    defaultFileName: "typing",
    hideMyProjects: true,
    createProjectsInProjects: true,
    description:
      "CS Typing Tutor makes learning fun and helps you develop proper finger placement.",
    coverColor: '#D7BEF7',
  },
  mit_app_inventor: {
    logo: mitLogo,
    hideMyProjects: true,
    route: "/mit/",
    projectStackDisplayName: "Mit App Inventor",
    description:
      "MIT App Inventor is a high-level block-based visual programming language, originally built by Google and now maintained by the Massachusetts Institute of Technology.",
    coverColor: '#D7BEF7',
  },
  mit_app_inventor_2: {
    logo: mitLogo,
    hideMyProjects: true,
    route: "/mit2/",
    projectStackDisplayName: "Mit App Inventor 2",
    description:
      "MIT App Inventor 2 is a high-level block-based visual programming language, originally built by Google and now maintained by the Massachusetts Institute of Technology.",
    coverColor: '#D7BEF7',
  },
  makecode: {
    logo: makeCodeLogo,
    route: "/makecode/",
    // openInNewTab: true,
    projectStackDisplayName: "MakeCode",
    description:
      "MakeCode is a platform for creating engaging computer science learning experiences that support a progression path into real-world programming.",
    coverColor: '#FFECD2',
  },
  arduino: {
    logo: arduinoLogo,
    route: "/arduinoide/",
    projectStackDisplayName: "Arduino",
    defaultFileName: "sketch.ino",
    createProjectsInProjects: true,
    description:
      "Arduino is an open-source electronics platform based on easy-to-use hardware and software.",
    coverColor: '#d1fdff',
  },
  tuxpaint: {
    logo: tuxpaintLogo,
    route: "/tuxpaint/",
    hideMyProjects: false,
    projectStackDisplayName: "Tux Paint",
    beta: true,
    description:
      "Tux Paint is a free, award-winning drawing program for children ages 3 to 12. It combines an easy-to-use interface and fun sound effects.",
    coverColor: '#fee686',
  },
  gdocs: {
    logo: gdocsLogo,
    projectStackDisplayName: "Google Docs",
    route: "/gapp/gdocs/",
    defaultFileName: "Untitled Document",
    fileMimeType: "application/vnd.google-apps.document",
    description:
      "Google Docs is a free, online word processor included as part of the free, web-based Google Docs Editors suite.",
    coverColor: '#c8e0ffff',
    createProjectsInProjects: true
  },
  gsheets: {
    logo: gsheetLogo,
    projectStackDisplayName: "Google Sheets",
    route: "/gapp/gsheets/",
    defaultFileName: "Untitled Spreadsheet",
    fileMimeType: "application/vnd.google-apps.spreadsheet",
    description:
      "Google Sheets is a free, online spreadsheet program included as part of the free, web-based Google Docs Editors suite.",
    coverColor: '#dfffebff',
    createProjectsInProjects: true
  },
  gslides: {
    logo: gslideLogo,
    projectStackDisplayName: "Google Slides",
    route: "/gapp/gslides/",
    defaultFileName: "Untitled Presentation",
    fileMimeType: "application/vnd.google-apps.presentation",
    description:
      "Google Slides is a free, online presentation program included as part of the free, web-based Google Docs Editors suite.",
    coverColor: '#fff6d2ff',
    createProjectsInProjects: true
  },
  gforms: {
    logo: gformsLogo,
    projectStackDisplayName: "Google Forms",
    route: "/gapp/gforms/",
    defaultFileName: "Untitled Form",
    fileMimeType: "application/vnd.google-apps.form",
    description:
      "Google Forms is a free, online form builder included as part of the free, web-based Google Docs Editors suite.",
    coverColor: '#E5D6FF',
    createProjectsInProjects: true
  },
  AI_for_oceans: {
    logo: aiforoceansLogo,
    route: "/ai-for-oceans/",
    hideMyProjects: true,
    projectStackDisplayName: "AI for Oceans",
    description:
      "AI for Oceans is an educational activity focused on using artificial intelligence to study and protect marine ecosystems.",
    coverColor: '#97eeeb',
  },
};

const evaluationStatusMetaMapping = {
  Evaluated: {
    color: "#2AC14E",
  },
  "Ask for resubmission": {
    color: "#7090F5",
    displayName: "Asked to resubmit",
  },
};

function getEvaluationStatusColor(evaluationStatus) {
  return evaluationStatusMetaMapping[evaluationStatus]
    ? evaluationStatusMetaMapping[evaluationStatus].color
      ? evaluationStatusMetaMapping[evaluationStatus].color
      : "#7090F5"
    : "#E96358";
}

function getEvaluationStatusName(evaluationStatus) {
  if (!evaluationStatus) {
    return "Pending Evaluation";
  }

  return evaluationStatusMetaMapping[evaluationStatus]
    ? evaluationStatusMetaMapping[evaluationStatus].displayName
      ? evaluationStatusMetaMapping[evaluationStatus].displayName
      : evaluationStatus
    : evaluationStatus;
}

function getFileExtension(filename) {
  // Split the filename by the dot (.)
  const parts = filename.split(".");

  // Get the last part of the split string (which is the extension)
  const extension = parts[parts.length - 1];

  // Return the extension in lowercase (optional)
  return extension.toLowerCase();
}

function toUtcAwareDate(date_) {
// Treat timezone-less backend timestamps as UTC; leave timezone-aware timestamps unchanged
  if (typeof date_ === "string" && !/(Z|[+-]\d{2}:?\d{2})$/.test(date_)) {
    const isoLike = date_.includes("T") ? date_ : date_.replace(" ", "T");
    return new Date(`${isoLike}Z`);
  }
  return new Date(date_);
}

function formatDate(date_) {
  if (!date_) return "";
  const date = toUtcAwareDate(date_);
  if (isNaN(date.getTime())) {
    return "";
  }

  return `${date.toLocaleString("en-US", {
    month: "long",
  })} ${date.getDate()}, ${date.getFullYear()} at ${date.toLocaleString(
    "en-US",
    { hour: "numeric", minute: "numeric", hour12: true }
  )}`;
}

function formatDateMonth(date_) {
  if (!date_) return "";
  const date = toUtcAwareDate(date_);
  if (isNaN(date.getTime())) {
    return "";
  }
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const monthIndex = date.getMonth();
  const day = date.getDate();
  const year = date.getFullYear();

  return `${months[monthIndex]} ${day}, ${year}`;
}

function getIdeProjectTypeMetaData(projectStack) {
  return projectStackMetaMapping[projectStack];
}

function getProjectTypeDisplayName(projectStack) {
  if (projectStack && projectStackMetaMapping[projectStack]) {
    return projectStackMetaMapping[projectStack].projectStackDisplayName || projectStack;
  }

  if (projectStack && typeof projectStack === 'string') {
    const normalizedStack = projectStack.trim().toLowerCase();
    if (projectStackMetaMapping[normalizedStack]) {
      return projectStackMetaMapping[normalizedStack].projectStackDisplayName || normalizedStack;
    }
  }

  return projectStack || 'Unknown Project';
}

function getShowMyProjectFlag(projectStack) {
  return projectStackMetaMapping[projectStack]
    ? projectStackMetaMapping[projectStack].hideMyProjects
    : false;
}

function getShowTutorialVideo(projectStack) {
  return projectStackMetaMapping[projectStack]
    ? projectStackMetaMapping[projectStack].tutorialVideoUrl
    : false;
}

function getIdeProjectLogo(projectStack) {
  return projectStackMetaMapping[projectStack]
    ? projectStackMetaMapping[projectStack].logo
    : pythonLogo;
}

function getIdeProjectRoute(projectStack) {
  return projectStackMetaMapping[projectStack]
    ? projectStackMetaMapping[projectStack].route
      ? projectStackMetaMapping[projectStack].route
      : false
    : false;
}

function getCurrentGreetingMessage() {
  const currentTime = new Date();
  const currentHour = currentTime.getHours();

  let greeting = "";
  let icon = "";

  if (currentHour < 12) {
    greeting = "Good Morning";
    icon = "sun";
  } else if (currentHour < 18) {
    greeting = "Good Afternoon";
    icon = "cloud-sun";
  } else {
    greeting = "Good Evening";
    icon = "moon";
  }

  return { greeting, icon };
}

function trackEvent(eventName, params) {
  params.user_login_id = global_var.user_login_id;
  params.user_name = global_var.user_name;
  params.role_name = global_var.role_name;
  params.company_id = global_var.company_id;
  params.company_name = global_var.company_name;
  params.platform = global_var.platform;
  ReactGA.event(eventName, params);
}
let isMobile = false;
function isMobileDevice() {
  if (window.innerWidth <= 767) {
    isMobile = true
  }
}
isMobileDevice()
function getCssClassNameForAutoSize(
  component,
  fileManagerExpanded,
  outputWindowExpanded
) {
  if (isMobile) {
    fileManagerExpanded = false;
  }

  if (component === "code-editor") {
    if (!fileManagerExpanded && outputWindowExpanded) {
      return "col-md-6 col-11";
    } else {
      return outputWindowExpanded ? "col-11 col-md-7" : "col";
    }
  } else if (component === "output-window") {
    if (!outputWindowExpanded) {
      return "d-none";
    } else {
      return fileManagerExpanded ? "col-11 col-md-5" : "col-11 col-md-6";
    }
  } else if (component === "file-manager") {
    if (isMobile) {
      return "d-none";
    }
    return fileManagerExpanded ? "col-3 col-md-2 border-end" : "d-none";
  } else if (component === "code-editor-output-container") {
    return fileManagerExpanded ? "col-md-10 col-9" : "col";
  }
}

export {
  getFileExtension,
  formatDate,
  getIdeProjectLogo,
  getIdeProjectRoute,
  getCurrentGreetingMessage,
  getEvaluationStatusColor,
  getIdeProjectTypeMetaData,
  getProjectTypeDisplayName,
  getShowMyProjectFlag,
  getShowTutorialVideo,
  trackEvent,
  getCssClassNameForAutoSize,
  getEvaluationStatusName,
  isMobile,
  formatDateMonth,
};
